import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsAcriss } from "../../@hooks"


export default function UserSettingsAcrissTabButton() {

    const { handleSetAcrissFormData } = useUserSettingsAcriss()

    return <AppToolbarCreateButton
        label="Define ACRISS Color"
        onClick={handleSetAcrissFormData}
    />
}